import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import CustomerDataProvider, { useCustomerData } from "@cinch-labs/customer-data-segment";
import cx from "classnames";
import { useEffect } from "react";
import BlackFridayBanner from "./black-friday";
import DepositContributionBanner from "./deposit-contribution/deposit-contribution";
import InfoBanner from "./info-banner";
import { default as SalePromoBanner } from "./sale";
import styles from "./shared-ui-promo-banner.module.css";
import SpringSalePromoBanner from "./spring-sale/spring-sale-promo-banner";
import WinterSale from "./winter-sale";
import { default as XmasPromoBanner } from "./xmas";
export function SharedPromoBanner(props) {
    return /*#__PURE__*/ _jsx(CustomerDataProvider, {
        children: /*#__PURE__*/ _jsx(PromoBanner, _object_spread({}, props))
    });
}
function PromoBanner(param) {
    var name = param.name, sendDigitalDataEvent = param.sendDigitalDataEvent, className = param.className;
    var trackEvent = useCustomerData().trackEvent;
    useEffect(function() {
        trackEvent({
            type: "track",
            eventName: "Promotion Viewed",
            data: {
                name: name,
                position: "top banner"
            }
        });
    }, []);
    var ComponentMap = new Map([
        [
            "sale",
            /*#__PURE__*/ _jsx(SalePromoBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "xmas",
            /*#__PURE__*/ _jsx(XmasPromoBanner, {})
        ],
        [
            "info",
            /*#__PURE__*/ _jsx(InfoBanner, {})
        ],
        [
            "winter-sale",
            /*#__PURE__*/ _jsx(WinterSale, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "blackFriday",
            /*#__PURE__*/ _jsx(BlackFridayBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            }), 
        ],
        [
            "deposit-contribution",
            /*#__PURE__*/ _jsx(DepositContributionBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            }), 
        ],
        [
            "spring-sale",
            /*#__PURE__*/ _jsx(SpringSalePromoBanner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            }), 
        ], 
    ]);
    var Child = ComponentMap.get(name);
    if (!Child) return null;
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles.container, className, (_obj = {}, _define_property(_obj, styles.depositContributionContainer, name === "deposit-contribution"), _define_property(_obj, styles.containerInfo, name === "info" || name === "spring-sale"), _obj)),
        children: Child
    });
}
